import { render, staticRenderFns } from "./instalment-info-card.vue?vue&type=template&id=1563a6b5&scoped=true&"
import script from "./instalment-info-card.vue?vue&type=script&lang=js&"
export * from "./instalment-info-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563a6b5",
  null
  
)

export default component.exports